<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-about.png`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企业使命</h2>
				<div class="product product-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						船水科技自成立以來，始終以「擁抱技術」為使命，依託全球領先技術與自主創新核心能力，驅動產業數字化轉型與數字經濟發展。在數字時代背景下，堅持「數雲融合」戰略定位，深度融合雲原生、數字原生、AI原生及信創產業四大技術引擎，構建覆蓋企業數字化轉型全周期的能力矩陣。
					</div>
					<div class="pic">
						<img src="@/assets/images/about1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<separator></separator>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">行业赋能与创新</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/about2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" style="font-size: 20px">
						面向快消零售、汽車、金融、醫療等核心行業，提供「雙能力」支撐：<br>
						敏捷IT底座：通過多雲異構資源統一納管，實現算力彈性調度與全棧信創適配；<br>
						數據驅動引擎：整合多源異構數據（系統數據+另類數據），構建跨域融合的數據資產化平台。<br>
						以此賦能客戶打造數字業務新場景（如智能供應鏈、AI風控），建立面向未來的核心競爭力。<br>
						在生成式AI驅動下，企業數據資產價值創造進入「加速範式」：<br>
						從依賴人工數據編排，實現靜態資產化；到現在大模型對高價值知識進行自動化處理與創造性再生，推動數據資產規模以十倍速級爆發式增長，步入不斷自我強化的新時代。
					</div>
				</div>
			</div>
		</div>

		<separator></separator>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">未来挑战</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						面對數據量指數增長、AI應用持續疊加、多雲異構環境治理的新時代「三重複雜性」挑戰，我們堅持：<br>
						智能治理體系：通過AI驅動的數據分級分類、動態脫敏與合規審計，應對數據資產安全風險；<br>
						多雲協同中樞：構建跨雲資源調度、策略聯動與成本優化的智能管理平台，破解異構環境運維困局。
					</div>
					<div class="pic">
						<img src="@/assets/images/about3.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Separator from '../../components/elements/separator/Separator'
import Swiper from 'swiper'

import "swiper/css/swiper.css";

export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {
		}
	},
}
</script>
<style lang="scss" scoped>
.product {
	margin-top: 72px;
	display: flex;
	gap: 20px;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		flex: 1;
		font-size: 22px;
		text-align: justify;
		display: flex;
		align-items: center;
	}
}

@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
</style>
